import { useMessagingInbox } from './useMessagingInbox'

/**
 * Resolves which device to use when opening a conversation for a client.
 *
 * Resolution:
 *  - Client already linked to a device → use that device directly
 *  - Not linked                        → caller must show a picker with all franchise devices
 */
export function useDeviceSelector() {
  const { devices } = useMessagingInbox()

  /**
   * @param {Object} client
   * @param {string|number|null} client.device_id           - linked device ID (from DB)
   * @param {string|number|null} client.whatsapp_device_id  - legacy alias (backward compat)
   * @param {string|number}      client.cliente_franquia_id - client's franquia
   *
   * @returns {{ deviceId: string|null, needsPicker: boolean, candidates: Array }}
   */
  const resolveDevice = (client: any) => {
    const linkedDeviceId = client.device_id || client.whatsapp_device_id
    if (linkedDeviceId) {
      return {
        deviceId: String(linkedDeviceId),
        needsPicker: false,
        candidates: [],
      }
    }

    // Filter devices that serve this client's franquia
    const franquiaId = String(client.cliente_franquia_id)
    const candidates = devices.value.filter(
      (d: any) => (d as any).franquiaIds?.includes(franquiaId)
    )

    return { deviceId: null, needsPicker: true, candidates }
  }

  /**
   * Build normalized phone string from a client row.
   */
  const buildPhone = (client: any) => {
    return [client.cliente_ddi, client.cliente_ddd, client.cliente_telefone]
      .map(s => (s || '').replace(/\D/g, ''))
      .join('')
  }

  return { resolveDevice, buildPhone }
}
